import { useCurrentPairFromUrl } from '@/features/pair/hook';
import { useTradeMaxLeverage, useTradeStoreTransformed } from '@/features/trade/hooks';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useMediaQueryDevice } from '../MediaQuery';
import TradeLeverageSimple from '../TradeLeverageSimple';
import WrappedNormalButton from '../WrappedNormalButton';
import './index.less';

export const TradeLeverageForm: React.FC = () => {
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const pair = useCurrentPairFromUrl(chainId);
  const [leverage, setLeverage] = useState('1');
  const { t } = useTranslation();
  const maxLeverage = useTradeMaxLeverage(pair?.maxLeverage);
  const { updatePairLeverage, setShowTradeAreaOverlay, leverage: pairLeverage } = useTradeStoreTransformed();
  const { isMobile } = useMediaQueryDevice();

  const handleLeverageUpdate = () => {
    if (userAddr && chainId && pair?.id) {
      updatePairLeverage(userAddr, chainId, pair.id, leverage);
      setShowTradeAreaOverlay(undefined);
    }
  };
  useEffect(() => {
    setLeverage(pairLeverage || maxLeverage);
    // no deps
  }, []);
  return (
    <div className="trade-leverage-form">
      <div className="trade-leverage-form-content">
        <div className="trade-leverage-form-tip trade-leverage-form-tip1">
          The leverage used for open positions and open orders on ETH/USDC pair. The maximum leverage is 15x.
        </div>
        <TradeLeverageSimple
          leverage={leverage}
          leverageChanged={setLeverage}
          maxLeverage={maxLeverage}
          mobileUseDesktopStyle={isMobile}
        />
        <div className="trade-leverage-form-tip trade-leverage-form-tip2">
          Selecting higher leverage increases your liquidation risk. Always manage your risk levels.
        </div>
        <div className="trade-leverage-form-footer">
          <WrappedNormalButton onClick={handleLeverageUpdate} type="primary" size="large" block>
            {t('common.confirm')}
          </WrappedNormalButton>
        </div>
      </div>
    </div>
  );
};

export default TradeLeverageForm;
